import React, {FC, lazy, Suspense} from "react";
import {Header} from "./components/Header/Header";

import style from './styles/app.module.scss';
import {Content} from "./components/Content/Content";
import {useIsMobile} from "./hooks/useIsMobile";
import {useMenuSelector} from "./redux/slices/menu";

const Menu = lazy(() => import("./components/Menu/Menu"));

export const App: FC = () =>
{
    const isMobile = useIsMobile();

    const { show } = useMenuSelector();

    return (
        <>
            <Header />
            <div className={style.mainLayout}>
                <Suspense fallback={null}>
                    { (!isMobile || (isMobile && show)) && <Menu /> }
                </Suspense>
                <Content />
            </div>
        </>
    )
}
